import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <span>© Sri Takshashila Gurukul, All rights reserved.</span>
        </div>
        <div className="footer-right">
          <span>
            Designed By <a href="/">Kavya Naganur</a>
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
